import { FC } from 'react';
import { createPortal } from 'react-dom';
import { Tooltip } from 'react-tooltip';
import styles from './FilterChipTooltip.module.css';

export interface FilterChipTooltipProps {
  id: string;
  /** Omit when anchors provide their own text via `data-tooltip-content` (one tooltip shared by many chips). */
  content?: string;
}

/**
 * Filter-type tooltip shown under filter chips. Rendered into `document.body` because chips live in
 * containers that clip it otherwise: `overflow: hidden` rows (carousels, filter bars) and the AI chat
 * drawer, whose `transform` makes `position: fixed` relative to the drawer instead of the viewport.
 */
const FilterChipTooltip: FC<FilterChipTooltipProps> = ({ id, content }) =>
  createPortal(
    <Tooltip
      id={id}
      content={content}
      delayShow={100}
      place="bottom"
      positionStrategy="fixed"
      className={styles.tooltip}
    />,
    document.body,
  );

export default FilterChipTooltip;
